import { Talk } from 'model';

const talks: Talk[] = [
  {
    date: '2026-01-13',
    title: 'Optimising Software Tracing Overhead in Meta-Tracing Just-In-Time Compilers',
    description:
      'Presentation about my research on optimising software tracing overhead in meta-tracing just-in-time compilers; explaining yk SWT and INTT overhead, and a multi-version IR call routing approach achieving up to 21.5% speedups."',
    url: 'https://drive.proton.me/urls/FVBHENB5S4#FUzL5dIVQFlM'
  },
  {
    date: '2022-11-29',
    title: 'Research Proposal - Language Composition',
    description: 'Language Composition research proposal presentation as part of my admission for part-time PhD',
    url: 'https://drive.proton.me/urls/F47YJ3K78W#qoRPMFB6xO0S'
  },
  {
    date: '2022-06-13',
    title: 'A universal all-in-one intelligent payments shopping app - Enginears Podcast',
    description:
      'Me talking on Enginears podcast with Elliot Kipling about how our tech looks and feels like at nate and my journey so far from a technical perspective. It was a pleasure',
    url: 'https://www.youtube.com/watch?v=JBhyXc4gaSE&t=1857s'
  },
  {
    date: '2022-05-09',
    title: 'Protobufs',
    description: 'Protobufs, forward, backward and full compatibility and supportive tools',
    url: 'https://docs.google.com/presentation/d/1WAAljjz5_2AZE5O5yafN6HXJdKGfBp6r/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2021-05-14',
    title: 'Apache Cassandra',
    description:
      'Cloud theory and CAP Theorem. Overview of NoSQL databases and Apache Cassandra column-oriented database designed to handle large amounts of data across many commodity servers',
    url: 'https://docs.google.com/presentation/d/1XC_gVQbTU_hAf9srzV_XgQYDHI3uYiqK/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2021-05-7',
    title: 'Cloud Theory - Byzantine fault tolerance',
    description: 'Cloud theory and CAP Theorem. Byzantine fault tolerance (BFT) and CAP Theorem',
    url: 'https://docs.google.com/presentation/d/11Ri_B6OaQOQfae2IXlkaUD2swv5cMNG0/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2021-04-23',
    title: 'CAP Theorem Intro',
    description: 'Cloud theory and CAP Theorem series introduction',
    url: 'https://docs.google.com/presentation/d/1TMOV8OcnxKURCPdw9Ws1gsn31oLKMiTI/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },

  {
    date: '2021-04-30',
    title: 'ACID vs BASE',
    description: 'Cloud theory and CAP Theorem. Overview of ACID, BASE how they compare and when to use them',
    url: 'https://docs.google.com/presentation/d/1irt9sypLYFq19xoLqyRB-SYVwY0UXZqw/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2021-06-4',
    title: 'MapReduce',
    description: 'Overview of Hadoop and MapReduce',
    url: 'https://docs.google.com/presentation/d/1b8NyNbgaAeo9zWzJ8_HbbJidqnO8_ko_/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2022-05-13',
    title: 'Disaster recovery, disaster',
    description:
      'Talking about general approach to disaster recovery, when and how its applicable strategy. In my case it was a premature optimization when we tried to address multiple problems at once',
    url: 'https://docs.google.com/presentation/d/1-KVH401qcUQck8DvD81g4-ptfxHNT7do/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2021-06-25',
    title: 'linux + namespaces + cgroups + docker',
    description: 'Talk about containerization, how it works under the hood and what paved the way for it',
    url: 'https://docs.google.com/presentation/d/1b5w6nOfy9tmif0cAW-BovqJUy9uzpMn7/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2020-09-15',
    title: 'Introduction to WebAssembly (WASM)',
    description:
      'Introduction to WebAssembly. WebAssembly is a new type of low-level assembly-like language that can be run in modern web browsers',
    url: 'https://docs.google.com/presentation/d/1f_Sw-YtEmb81Zm5QwY5FFiOUuthC7sFa/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2020-04-17',
    title: 'Algorithms analysis & big O notation',
    description:
      'Very high level overview of algorithms analysis and big O notation. Used as a refresher for those who forgot, or as a starting point for those who never heard of it',
    url: 'https://docs.google.com/presentation/d/1rL83knworsX9HYdFa-uMj4FBePqLUJRa/edit?usp=sharing&ouid=110168213891892877520&rtpof=true&sd=true'
  },
  {
    date: '2020-03-13',
    title: 'Node.js Event Looooooooooooooop',
    description: 'What’s node? What’s the event loop? How does it work? How does it affect our code?',
    url: 'https://drive.google.com/file/d/1ZYkym-LiSYiMT5G0HDCccKCng62JD4rF/view?usp=sharing'
  }
];

export default talks;
